export const shouldShowStrikeThroughPrice = (price, strikeThroughPrice, isOnlyOneFareFamilyRateCase) =>
  strikeThroughPrice && !isOnlyOneFareFamilyRateCase ? price < strikeThroughPrice : false;

export const getIsOnlyOneFareFamilyRateCase = rateFamilies =>
  rateFamilies?.length === 1 && rateFamilies[0]?.rates?.length === 1;

export const getIsTwoRatesFareFamilyRateCase = rateFamilies =>
  rateFamilies?.length === 1 && rateFamilies[0]?.rates?.length === 2;
